import ImportResources from "./ImportResources";
import Buildings from "./Buildings";

export default {
    "apartments.resource-bindings": ImportResources,
    "apartments.buildings": Buildings,
};
